<template>
  <div>
    <RevDrawer
      name="modal.listings.tab.filters.mobile"
      :title="i18n(sharedTranslations.title)"
    >
      <template #body>
        <form>
          <div class="flex flex-col space-y-12">
            <RevInputText
              v-if="shouldShowFilter(FILTER_FIELDS.TITLE)"
              :id="FILTER_FIELDS.TITLE"
              v-model="filtersValues.title"
              :label="i18n(sharedTranslations.title)"
              type="text"
            />
            <RevInputText
              v-if="shouldShowFilter(FILTER_FIELDS.SKU)"
              :id="FILTER_FIELDS.SKU"
              v-model="filtersValues.sku"
              :label="i18n(sharedTranslations.sku)"
              type="text"
            />
            <RevInputSelect
              v-if="shouldShowFilter(FILTER_FIELDS.BACKBOX)"
              :id="FILTER_FIELDS.BACKBOX"
              v-model="filtersValues.hasBackbox"
              :label="i18n(sharedTranslations.backbox)"
              :options="backboxOptions"
            />
            <RevInputSelect
              v-if="shouldShowFilter(FILTER_FIELDS.STOCK)"
              :id="FILTER_FIELDS.STOCK"
              v-model="filtersValues.hasStock"
              :label="i18n(sharedTranslations.stock)"
              :options="stockOptions"
            />
            <RevInputText
              v-if="shouldShowFilter(FILTER_FIELDS.UUID)"
              :id="FILTER_FIELDS.UUID"
              v-model="filtersValues.productId"
              :label="i18n(sharedTranslations.uuid)"
              type="text"
            />
            <RevInputText
              v-if="shouldShowFilter(FILTER_FIELDS.BACKMARKET_ID)"
              :id="FILTER_FIELDS.BACKMARKET_ID"
              v-model="filtersValues.bmId"
              :label="i18n(sharedTranslations.backmarketId)"
              type="text"
            />
            <RevInputSelect
              v-if="shouldShowFilter(FILTER_FIELDS.GRADE)"
              :id="FILTER_FIELDS.GRADE"
              v-model="filtersValues.aestheticGrade"
              :label="i18n(sharedTranslations.grade)"
              :options="gradesOptions"
            />
            <RevInputSelect
              v-if="shouldShowFilter(FILTER_FIELDS.ALERT)"
              :id="FILTER_FIELDS.ALERT"
              v-model="filtersValues.priceOverNew"
              :label="i18n(sharedTranslations.alerts)"
              :options="alertOptions"
            />
            <RevInputSelect
              v-if="shouldShowFilter(FILTER_FIELDS.MARKET)"
              :id="FILTER_FIELDS.MARKET"
              v-model="filtersValues.market"
              :label="i18n(sharedTranslations.market)"
              :options="availableMarketsOptions"
            />
            <SelectCategory
              v-if="shouldShowFilter(FILTER_FIELDS.CATEGORY_ID)"
              :id="FILTER_FIELDS.CATEGORY_ID"
              v-model="filtersValues.categoryId"
            />
            <RevInputSelect
              v-if="shouldShowFilter(FILTER_FIELDS.HAS_NEW_BATTERY)"
              :id="FILTER_FIELDS.HAS_NEW_BATTERY"
              v-model="filtersValues.hasNewBattery"
              :label="i18n(sharedTranslations.hasNewBattery)"
              :options="hasNewBatteryOptions"
            />
          </div>
        </form>
      </template>
      <template #footer="{ close }">
        <div class="flex">
          <RevButton
            class="mr-6"
            full-width="always"
            type="submit"
            variant="primary"
            @click="handleSubmit(close)"
          >
            {{ i18n(sharedTranslations.submit) }}
          </RevButton>

          <RevButton
            full-width="always"
            variant="secondary"
            @click="handleReset(close)"
          >
            {{ i18n(sharedTranslations.resetFilters) }}
          </RevButton>
        </div>
      </template>
      <template #trigger="{ open }">
        <RevStickyBar>
          <div class="flex items-center justify-center">
            <RevButton
              :icon="IconEqualizer"
              size="small"
              variant="secondary"
              @click="open"
            >
              {{ i18n(sharedTranslations.filter) }}
            </RevButton>
          </div>
        </RevStickyBar>
      </template>
    </RevDrawer>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevStickyBar } from '@ds/components/StickyBar'
import { IconEqualizer } from '@ds/icons/IconEqualizer'

import SelectCategory from '../../../../../../../../components/Input/SelectCategory/SelectCategory.vue'
import { useFiltersOptions } from '../../../../composables/useFiltersOptions'
import { FILTER_FIELDS } from '../../Filters.constants'
import sharedTranslations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

const props = defineProps<{
  resetFilters: () => void
  submitFilters: () => void
  shouldShowFilter: (filter: string) => boolean
  shouldShowMissingActionFilter: boolean
  shouldShowOrderStateFilter: boolean
}>()

const i18n = useI18n()

const {
  alertOptions,
  availableMarketsOptions,
  backboxOptions,
  gradesOptions,
  hasNewBatteryOptions,
  stockOptions,
} = useFiltersOptions()

function handleSubmit(closeModal: () => void) {
  props.submitFilters()
  closeModal()
}

function handleReset(closeModal: () => void) {
  props.resetFilters()
  closeModal()
}
</script>
